import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Row, Col, Input, Form } from 'reactstrap';
import { AccountType, CreateAccount, EmailAddress, EmailsPlaceHolder, FirstName, LastName, Password } from '../../../utils/Constant';
import { Btn, H4, P } from '../../../AbstractElements';
import { createUserByAdminAction, registerAction, updateUserAction, updateUserByAdminAction } from '../../../Api/auth';
import { toast } from 'react-toastify';

interface CreateUserModalProps {
  modal: boolean
  setModal: (isModal: boolean) => void;
  users: any
  setUsers: (users: any) => void;
}

const CreateUserModal: React.FC<CreateUserModalProps> = ({ modal, setModal, users, setUsers }) => {

  const toggle = () => setModal(!modal);
  const [showPassWord, setShowPassWord] = useState(false);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [role, setRole] = useState("")
  const [passwordMatched, setPasswordMatched] = useState(false)
  const [phonenumber, setPhoneNumber] = useState("");

  const createUserByAdmin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!passwordMatched) return;
    const _user = {
      firstname, lastname, email, password, phonenumber, 
      role: "clinician"
    }
    const { user, response } = await createUserByAdminAction(_user)
    if (user !== undefined) {
      setUsers([...users, user])
      toast.success("Created User Successfully!");
      toggle()
    }
    else {
      const _response: any = response
      if (_response?.response)
        toast.error(_response.response.data.message)
      else
        toast.error("User creation failed!")
    }
  };

  useEffect(() => {
    if (password !== confirmPassword) setPasswordMatched(false)
    if (password === confirmPassword) setPasswordMatched(true)
  }, [password, confirmPassword])


  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Create User</ModalHeader>
        <ModalBody>
          <Form className="theme-form" onSubmit={(event) => createUserByAdmin(event)}>
            <FormGroup>
              <Label className="col-form-label pt-0">{"User Name"}</Label>
              <Row className="g-2">
                <Col xs="6">
                  <Input type="text" required placeholder={FirstName} onChange={(event) => setFirstName(event.target.value)} />
                </Col>
                <Col xs="6">
                  <Input type="text" required placeholder={LastName} onChange={(event) => setLastName(event.target.value)} />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Label className="col-form-label">{EmailAddress}</Label>
              <Input type="email" required placeholder={EmailsPlaceHolder} onChange={(event) => setEmail(event.target.value)} />
            </FormGroup>
            <FormGroup>
              <Label className="col-form-label">{Password}</Label>
              <div className="form-input position-relative">
                <Input type={showPassWord ? "text" : "password"} placeholder="*********" required autoComplete='' onChange={(event) => setPassword(event.target.value)} />
                <div className="show-hide">
                  <span onClick={() => setShowPassWord(!showPassWord)} className={!showPassWord ? "show" : ""} />
                </div>
              </div>
            </FormGroup>
            <FormGroup>
              <Label className="col-form-label">{"Confirm Password"}</Label>
              <div className="form-input position-relative">
                <Input type={showPassWord ? "text" : "password"} placeholder="*********" required autoComplete='' onChange={(event) => setConfirmPassword(event.target.value)} />
                <div className="show-hide">
                  <span onClick={() => setShowPassWord(!showPassWord)} className={!showPassWord ? "show" : ""} />
                </div>
                {!passwordMatched ? <p className="text-danger mb-0">Password does not confirmed</p> : ""}
              </div>
            </FormGroup>

            <FormGroup>
              <Label className="col-form-label">{"Phone Number"}</Label>
              <Input type="text" placeholder={"Phone Number"} required onChange={(event) => setPhoneNumber(event.target.value)} />
            </FormGroup>
            <FormGroup className="mb-0">
              <Btn color="primary" className="w-100">{CreateAccount}</Btn>
            </FormGroup>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default CreateUserModal;